<template>
  <div>
    <ListView
      ref="listView"
      :isFluid="true"
      :dense="true"
      title="佑安保險代理公司"
      @reload="reload"
      @create="actionCreate"
      :search.sync="search"
      :data="data"
      :page.sync="page"
      :header="header"
      :itemClass="getCrmRowClass"
      :enableCreate="true"
      :search-box-placeholder="placeholder"
    >
      <!-- Custom Search Box -->
      <template v-slot:searchBox>
        <span></span>
      </template>

      <!-- Filter Section -->
      <template v-slot:filter>
        <v-row dense class="filter-row">
          <v-col cols="auto">
            <v-select
              v-model="pendingSearchField"
              :items="searchFieldOptions"
              dense
              outlined
              hide-details
              label="搜尋欄位"
            />
          </v-col>
          <v-col cols="auto">
            <v-text-field
              v-model="pendingSearchVal"
              dense
              outlined
              hide-details
              :placeholder="searchFieldLabel"
              prepend-inner-icon="mdi-magnify"
              clearable
              @keyup.enter="applyFilters"
            />
          </v-col>
          <v-col cols="auto">
            <v-select
              v-model="pendingFilters.insType"
              :items="insuranceTypeOptions"
              dense
              outlined
              hide-details
              label="保險種類"
              clearable
            />
          </v-col>
          <v-col cols="auto">
            <v-menu
              ref="businessDateStartMenu"
              v-model="businessDateStartMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="pendingFilters.businessDateStart"
                  label="起保日期 開始"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  dense
                  outlined
                  hide-details
                  clearable
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="pendingFilters.businessDateStart"
                @input="businessDateStartMenu = false"
                no-title
                scrollable
              />
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <v-menu
              ref="businessDateEndMenu"
              v-model="businessDateEndMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="pendingFilters.businessDateEnd"
                  label="起保日期 截止"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  dense
                  outlined
                  hide-details
                  clearable
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="pendingFilters.businessDateEnd"
                @input="businessDateEndMenu = false"
                no-title
                scrollable
              />
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <v-menu
              ref="endDateStartMenu"
              v-model="endDateStartMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="pendingFilters.endDateStart"
                  label="到期日期 開始"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  dense
                  outlined
                  hide-details
                  clearable
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="pendingFilters.endDateStart"
                @input="endDateStartMenu = false"
                no-title
                scrollable
              />
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <v-menu
              ref="endDateEndMenu"
              v-model="endDateEndMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="pendingFilters.endDateEnd"
                  label="到期日期 截止"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  dense
                  outlined
                  hide-details
                  clearable
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="pendingFilters.endDateEnd"
                @input="endDateEndMenu = false"
                no-title
                scrollable
              />
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <v-select
              v-model="pendingFilters.agency"
              :items="agencyOptions"
              dense
              outlined
              hide-details
              label="代理"
              clearable
            />
          </v-col>
          <v-col cols="auto">
            <v-select
              v-model="pendingFilters.depPlace"
              :items="depPlaceOptions"
              dense
              outlined
              hide-details
              label="附件"
              clearable
            />
          </v-col>
          <v-col cols="auto">
            <v-select
              v-model="pendingFilters.needFile"
              :items="needFileOptions"
              dense
              outlined
              hide-details
              label="待補文件"
              clearable
            />
          </v-col>
          <v-col cols="auto">
            <v-select
              v-model="pendingFilters.rnType"
              :items="rnTypeOptions"
              dense
              outlined
              hide-details
              label="RN狀態"
              clearable
            />
          </v-col>
          <v-col cols="auto" class="d-flex align-center">
            <v-checkbox
              v-model="pendingFilters.expiryAlert"
              hide-details
              dense
              class="mt-0 pt-1"
              label="只顯示-待續保優先項目"
            />
          </v-col>
          <v-col cols="auto">
            <v-select
              v-model="pendingSortBy"
              :items="sortOptions"
              dense
              outlined
              hide-details
              label="排序顯示"
            />
          </v-col>
          <v-col cols="auto" class="d-flex align-center gap-2">
            <v-btn color="primary" @click="applyFilters" :loading="isLoading" :disabled="isLoading">
              <v-icon left>mdi-magnify</v-icon>
              搜尋
            </v-btn>
            <v-btn color="default" @click="resetFilters" :disabled="isLoading">
              <v-icon left>mdi-refresh</v-icon>
              清除選項
            </v-btn>
            <v-btn color="default" @click="handlePrint" :disabled="isLoading">
              <v-icon left>mdi-printer</v-icon>
              列印
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <!-- Clickable hyperlink columns -->
      <template v-slot:item.ContactPerson="{ item }">
        <span v-if="isPrinting" class="contact-name-print-wrap">
          {{ item.ContactPerson }}
        </span>
        <a
          v-else-if="item.ContactPerson"
          class="clickable-link contact-name-ellipsis"
          @click.stop="openFilteredDialog('ContactPerson', item.ContactPerson)"
        >
          {{ item.ContactPerson }}
        </a>
      </template>
      <template v-slot:item.insType="{ item }">
        {{ item.insType | translateOptions(insuranceTypeOptions, 'value', 'text') }}
      </template>
      <template v-slot:item.VEHNO="{ item }">
        <a
          v-if="item.VEHNO"
          class="clickable-link"
          @click.stop="openFilteredDialog('data.VEHNO', item.VEHNO)"
        >
          {{ item.VEHNO }}
        </a>
      </template>
      <template v-slot:item.CNNO="{ item }">
        <a
          v-if="item.CNNO"
          class="clickable-link"
          @click.stop="openFilteredDialog('data.CNNO', item.CNNO)"
        >
          {{ item.CNNO }}
        </a>
      </template>
      <template v-slot:item.TEL="{ item }">
        <a
          v-if="item.TEL"
          class="clickable-link"
          @click.stop="openRenewalNoticeDialog(item)"
        >
          {{ item.TEL }}
        </a>
      </template>
      <template v-slot:item.agentTel="{ item }">
        <a
          v-if="item.agentTel"
          :href="generateWhatsAppUrl(item.agentTel, item)"
          target="_blank"
          class="clickable-link"
          @click.stop
        >
          {{ item.agentTel }}
        </a>
      </template>
      <template v-slot:item.businessDate="{ item }">
        {{ item.businessDate | moment('YYYY-MM-DD') }}
      </template>
      <template v-slot:item.endDate="{ item }">
        <span :class="{ 'error--text': isCrmSpecialRecord(item) }">
          <template v-if="item.endDate">{{ item.endDate | moment('YYYY-MM-DD') }}</template>
          <template v-else>—</template>
        </span>
      </template>
      <!-- <template v-slot:item.inputDate="{ item }">
        {{ item.inputDate | moment('YYYY-MM-DD') }}
      </template> -->
      <template v-slot:item._RN="{ item }">
        <div class="d-flex align-center flex-wrap">
          <span>{{ item._RN }}</span>
          <!-- Show clickable label if status is RN and RN field is empty -->
          <component
            :is="isPrinting ? 'span' : 'v-chip'"
            v-if="item.RNT === 'RN' && !item.RN"
            label
            color="primary"
            @click.stop="updateRNTimestamp(item)"
          >
            {{ item.RNT }}
          </component>
          <!-- Show clickable date if status is RN and RN field has value -->
          <a
            v-else-if="item.RNT === 'RN' && item.RN"
            class="clickable-link"
            @click.stop="openRNDateDialog(item)"
          >
            {{ item.RN | moment('YYYY-MM-DD') }}
          </a>

          <!-- Show normal label for other statuses -->
          <v-chip :is="isPrinting ? 'span' : 'v-chip'" label v-else-if="item.RNT" color="default">
            {{ item.RNT | translateOptions(rnTypeOptions, 'value', 'text') }}
          </v-chip>
          <v-btn
            icon
            x-small
            class="ml-2 no-print"
            @click.stop="openRNDialog(item)"
          >
            <v-icon x-small>mdi-pencil</v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon small color="primary" @click.stop="actionDetails(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>

        <div>
          <a
            v-if="item.needFile && item.needFile.includes('牌簙')"
            href="javascript:void(0)"
            class="clickable-link"
            @click.stop="openDocsRequestDialog(item)"
          >
            牌簙待補
          </a>
        </div>
      </template>
    </ListView>

    <CRMDetailsDialog
      v-model="editDialog"
      :id="editId"
      :initial-data="initialData"
      @saved="handleSaved"
      @deleted="handleDeleted"
      @duplicate="handleDuplicate"
    />

    <!-- RN Status Edit Dialog -->
    <v-dialog v-model="rnDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h6">編輯RN狀態</span>
          <v-spacer />
          <v-btn icon @click="closeRNDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="rnEditData.RNT"
                  :items="rnTypeOptions"
                  label="狀態選擇"
                  outlined
                  dense
                  :disabled="rnSaving"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="rnSaving" @click="closeRNDialog">取消</v-btn>
          <v-btn color="primary" :loading="rnSaving" :disabled="rnSaving" @click="updateRNStatus">
            立即提交
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- RN Date Edit Dialog -->
    <v-dialog v-model="rnDateDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h6">編輯RN日期</span>
          <v-spacer />
          <v-btn icon @click="closeRNDateDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-menu
                  ref="rnDateMenu"
                  v-model="rnDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="rnDateEditData.RNDate"
                      label="RN日期"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      clearable
                      :disabled="rnDateSaving"
                      v-bind="attrs"
                      v-on="on"
                      @click:clear="rnDateEditData.RNDate = null"
                    />
                  </template>
                  <v-date-picker
                    v-model="rnDateEditData.RNDate"
                    @input="rnDateMenu = false"
                    no-title
                    scrollable
                  />
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="rnDateSaving" @click="closeRNDateDialog">取消</v-btn>
          <v-btn
            color="primary"
            :loading="rnDateSaving"
            :disabled="rnDateSaving"
            @click="updateRNDate"
          >
            立即提交
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Cloud docs-request confirm dialog (牌簙待補) -->
    <v-dialog v-model="docsRequestDialog" max-width="560px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h6">確認發送牌簿待補 WhatsApp</span>
          <v-spacer />
          <v-btn icon :disabled="docsRequestSending" @click="closeDocsRequestDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-model="docsRequestForm.to"
                  label="收件人電話 (to)"
                  outlined
                  dense
                  readonly
                  :disabled="docsRequestSending"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="docsRequestForm.insuredName"
                  label="受保人 (insuredName)"
                  outlined
                  dense
                  readonly
                  :disabled="docsRequestSending"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="docsRequestForm.coverNoteNumber"
                  label="臨時保單號碼 (coverNoteNumber)"
                  outlined
                  dense
                  readonly
                  :disabled="docsRequestSending"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="docsRequestForm.vehicleMake"
                  label="廠商 (vehicleMake)"
                  outlined
                  dense
                  readonly
                  :disabled="docsRequestSending"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="docsRequestForm.vehicleModel"
                  label="型號 (vehicleModel)"
                  outlined
                  dense
                  readonly
                  :disabled="docsRequestSending"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="docsRequestForm.yearOfManufacture"
                  label="出廠年份 (yearOfManufacture)"
                  outlined
                  dense
                  readonly
                  :disabled="docsRequestSending"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="docsRequestSending" @click="closeDocsRequestDialog">
            取消
          </v-btn>
          <v-btn
            color="primary"
            :loading="docsRequestSending"
            :disabled="docsRequestSending"
            @click="sendDocsRequestWhatsapp"
          >
            發送
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Cloud renewal-notice confirm dialog (續保通知) -->
    <v-dialog v-model="renewalNoticeDialog" max-width="560px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h6">確認發送續保通知 WhatsApp</span>
          <v-spacer />
          <v-btn icon :disabled="renewalNoticeSending" @click="closeRenewalNoticeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-model="renewalNoticeForm.to"
                  label="收件人電話 (to)"
                  outlined
                  dense
                  readonly
                  :disabled="renewalNoticeSending"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="renewalNoticeForm.expiryDate"
                  label="到期日 (expiryDate)"
                  outlined
                  dense
                  readonly
                  :disabled="renewalNoticeSending"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="renewalNoticeForm.insuredName"
                  label="受保人 (insuredName)"
                  outlined
                  dense
                  readonly
                  :disabled="renewalNoticeSending"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="renewalNoticeForm.insuranceType"
                  label="保險種類 (insuranceType)"
                  outlined
                  dense
                  readonly
                  :disabled="renewalNoticeSending"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="renewalNoticeForm.policyNumber"
                  label="保單號碼 (policyNumber)"
                  outlined
                  dense
                  readonly
                  :disabled="renewalNoticeSending"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="renewalNoticeForm.licencePlate"
                  label="車牌 (licencePlate)"
                  outlined
                  dense
                  readonly
                  :disabled="renewalNoticeSending"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="renewalNoticeSending" @click="closeRenewalNoticeDialog">
            取消
          </v-btn>
          <v-btn
            color="primary"
            :loading="renewalNoticeSending"
            :disabled="renewalNoticeSending"
            @click="sendRenewalNoticeWhatsapp"
          >
            發送
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Filtered Table Dialog -->
    <CRMFilteredTableDialog
      v-model="filteredDialog"
      :filter-field="filterField"
      :filter-value="filterValue"
      @open-details="handleOpenDetails"
    />
  </div>
</template>

<script>
import { RESTFUL, rnTypes, crmOptionsSubTypes } from '@/data/constants';
import { insuranceTypeOptions, needFileOptions, rnTypeOptions } from '@/data/optionsConstants';
import listViewPageMixin from '@/services/listViewPageMixin';
import { mapGetters } from 'vuex';
import CRMDetailsDialog from '@/components/CRM/CRMDetailsDialog';
import CRMFilteredTableDialog from '@/components/CRM/CRMFilteredTableDialog';
import api from '@/api';
import dayjs from 'dayjs';
import { pick } from 'lodash';
import { translateOptions } from '@/services/filters';
import { getOptions } from '@/api/options';

export default {
  name: 'CRM',
  props: {},
  components: {
    CRMDetailsDialog,
    CRMFilteredTableDialog,
  },
  data() {
    return {
      limit: 100,

      populate: '',
      editDialog: false,
      editId: 'new',
      initialData: null,
      // RN Dialog data
      rnDialog: false,
      rnEditData: {
        _id: null,
        RNT: null,
      },
      rnSaving: false,
      // RN Date Dialog data
      rnDateDialog: false,
      rnDateMenu: false,
      rnDateEditData: {
        _id: null,
        RNDate: null,
      },
      rnDateSaving: false,
      // Cloud docs-request (牌簙待補)
      docsRequestDialog: false,
      docsRequestSending: false,
      docsRequestForm: {
        to: '',
        insuredName: '',
        coverNoteNumber: '',
        vehicleMake: '',
        vehicleModel: '',
        yearOfManufacture: '',
      },
      // Cloud renewal-notice (續保通知 via TEL)
      renewalNoticeDialog: false,
      renewalNoticeSending: false,
      renewalNoticeForm: {
        to: '',
        expiryDate: '',
        insuredName: '',
        insuranceType: '',
        policyNumber: '',
        licencePlate: '',
      },
      // Filter data
      searchField: 'ContactPerson',
      pendingSearchField: 'ContactPerson',
      pendingSearchVal: '',
      searchFieldOptions: [
        { text: '客戶名稱', value: 'ContactPerson' },
        { text: '車牌號碼', value: 'data.VEHNO' },
        { text: '電話', value: 'TEL' },
        { text: '檔案編號', value: 'N1' },
        { text: '代理人', value: 'agent' },
        { text: '代理人電話', value: 'agentTel' },
      ],
      filters: {
        insType: null,
        businessDateStart: null,
        businessDateEnd: null,
        endDateStart: null,
        endDateEnd: null,
        agency: null,
        depPlace: null,
        needFile: null,
        rnType: null,
        /** When true (after 搜尋), list only rows that show the red "!". */
        expiryAlert: false,
      },
      pendingFilters: {
        insType: null,
        businessDateStart: null,
        businessDateEnd: null,
        endDateStart: null,
        endDateEnd: null,
        agency: null,
        depPlace: null,
        needFile: null,
        rnType: null,
        expiryAlert: false,
      },
      businessDateStartMenu: false,
      businessDateEndMenu: false,
      endDateStartMenu: false,
      endDateEndMenu: false,
      sortBy: 'businessDate',
      pendingSortBy: 'businessDate',
      sort: { businessDate: -1 },
      sortOptions: [
        // { text: '按登記日期先後排序 ↑', value: 'inputDateAsc' },
        { text: '按登記日期先後排序 ↓', value: 'inputDate' },
        { text: '按起保日期先後排序 ↑', value: 'businessDateAsc' },
        { text: '按起保日期先後排序（默認） ↓', value: 'businessDate' },
        { text: '按到期日先後排序 ↑', value: 'endDateAsc' },
        { text: '按到期日先後排序 ↓', value: 'endDate' },
        // { text: '按數據ID先後排序 ↑', value: '_idAsc' },
        { text: '按數據ID先後排序 ↓', value: '_id' },
      ],
      insuranceTypeOptions,
      needFileOptions,
      rnTypeOptions,
      agencyOptions: [],
      depPlaceOptions: [],
      /** YYYY-MM-DD from system config `crm.CRM_EXPIRY_ALERT_END_DATE_FLOOR`; null until loaded. */
      crmExpiryAlertEndDateFloor: null,
      // Filtered Table Dialog data
      filteredDialog: false,
      filterField: '',
      filterValue: '',

      //print
      isPrinting: false,
    };
  },
  mixins: [listViewPageMixin],
  async mounted() {
    await this.loadOptions();
  },
  computed: {
    ...mapGetters('auth', ['role', 'isMaster']),
    mergeParams() {
      return {
        isSimple: true,
      };
    },
    restfulURL() {
      return RESTFUL.crm.list;
    },
    placeholder() {
      return '搜尋客戶名稱 / 車牌號碼 / 電話 / 檔案編號';
    },
    searchFieldLabel() {
      const field = this.searchFieldOptions.find(f => f.value === this.pendingSearchField);
      return field ? `請輸入${field.text}` : '請輸入搜尋內容';
    },
    searchPaths() {
      // Return the applied search field as search path
      return this.searchField ? [this.searchField] : undefined;
    },
    header() {
      return [
        { text: '客戶名稱', value: 'ContactPerson', width: '220px', class: 'crm-contact-person-col', cellClass: 'crm-contact-person-col' },
        { text: '保險種類', value: 'insType', width: '75px' },
        { text: '車牌號碼', value: 'VEHNO', width: '80px'},
        { text: '起保日期', value: 'businessDate', width: '80px'},
        { text: '到期日', value: 'endDate', width: '80px'},
        { text: '保險公司', value: 'NAMEOFINS', width: '80px', class: 'crm-nameofins-col', cellClass: 'crm-nameofins-col' },
        { text: '廠商', value: 'MAKE', width: '72px', class: 'crm-make-model-col', cellClass: 'crm-make-model-col' },
        { text: '型號', value: 'MODEL', width: '72px', class: 'crm-make-model-col', cellClass: 'crm-make-model-col' },
        { text: '年份', value: 'YEAR', width: '40px' },
        { text: '臨時保單號碼', value: 'CNNO' },
        { text: '正式保單號碼', value: 'POLICYNO' },
        { text: '電話', value: 'TEL' },
        { text: '代理人', value: 'agent' },
        { text: '代理人電話', value: 'agentTel' },
        { text: 'RN', value: '_RN' },
        { text: '檔案編號', value: 'N1' },
        { text: '附件', value: 'depPlace' },
        // { text: '登記日期', value: 'inputDate' },
        ...(this.isPrinting
          ? []
          : [
              {
                text: '操作',
                value: 'actions',
                sortable: false,
              },
            ]),
      ];
    },
    filter() {
      const filter = {};
      const orConditions = []; // Collect all $or conditions

      // Insurance type filter
      if (this.filters.insType) {
        filter.insType = this.filters.insType;
      }

      // Business date range filter
      if (this.filters.businessDateStart || this.filters.businessDateEnd) {
        filter.businessDate = {};
        if (this.filters.businessDateStart) {
          filter.businessDate.$gte = dayjs(this.filters.businessDateStart).startOf('day').toDate();
        }
        if (this.filters.businessDateEnd) {
          filter.businessDate.$lte = dayjs(this.filters.businessDateEnd).endOf('day').toDate();
        }
      }

      // End date range filter
      if (this.filters.endDateStart || this.filters.endDateEnd) {
        filter.endDate = {};
        if (this.filters.endDateStart) {
          filter.endDate.$gte = dayjs(this.filters.endDateStart).startOf('day').toDate();
        }
        if (this.filters.endDateEnd) {
          filter.endDate.$lte = dayjs(this.filters.endDateEnd).endOf('day').toDate();
        }
      }

      // Agency filter
      if (this.filters.agency) {
        filter.AGENCY = this.filters.agency;
      }

      // Deposit place filter
      if (this.filters.depPlace) {
        filter['data.depPlace'] = this.filters.depPlace;
      }

      // Need file filter
      if (this.filters.needFile) {
        filter.needFile = this.filters.needFile;
      }

      // RN type filter
      if (this.filters.rnType) {
        filter.RNT = this.filters.rnType;
        if (this.filters.rnType === rnTypes.RN) {
          orConditions.push({ $or: [{ RN: { $exists: false } }, { RN: '' }, { RN: null }] });
        }
      }

      // Combine all $or conditions with $and if multiple exist
      if (orConditions.length === 1) {
        filter.$or = orConditions[0].$or;
      } else if (orConditions.length > 1) {
        filter.$and = orConditions;
      }

      // Red row highlight: same rules as isCrmExpiryAlertActive; requires 搜尋 when using checkbox
      if (this.filters.expiryAlert) {
        const todayStart = dayjs().startOf('day').toDate();
        const endWindow = dayjs().add(2, 'day').endOf('day').toDate();
        const alertStart = this.crmExpiryAlertEndDateFloor
          ? dayjs(this.crmExpiryAlertEndDateFloor).startOf('day').toDate()
          : todayStart;
        const expiryAlertExcludedRnt = [
          rnTypes.Renewed,
          rnTypes.Cancelled,
          rnTypes.Abandoned,
          rnTypes.Sold,
          rnTypes.NonRenewal,
        ];
        const expiryBlock = {
          endDate: {
            $exists: true,
            $ne: null,
            $gte: alertStart,
            $lte: endWindow,
          },
          RNT: { $nin: expiryAlertExcludedRnt },
        };
        if (Object.keys(filter).length === 0) {
          Object.assign(filter, expiryBlock);
        } else {
          const rest = { ...filter };
          Object.keys(filter).forEach(k => delete filter[k]);
          filter.$and = [rest, expiryBlock];
        }
      }

      return Object.keys(filter).length > 0 ? filter : null;
    },
  },
  methods: {
    async handlePrint() {
      // Call the ListView's print method
      if (this.$refs.listView) {
        this.isPrinting = true;
        await this.$nextTick();
        this.$refs.listView.handlePrint();
        // await this.$nextTick();

        this.isPrinting = false;
      }
    },
    updateSort() {
      // Update the sort data property based on sortBy selection
      if (this.sortBy === 'inputDate') {
        this.sort = { inputDate: -1 };
        // } else if (this.sortBy === 'inputDateAsc') {
        // this.sort = { inputDate: 1 };
      } else if (this.sortBy === 'businessDateAsc') {
        this.sort = { businessDate: 1 };
      } else if (this.sortBy === 'endDate') {
        this.sort = { endDate: -1 };
      } else if (this.sortBy === 'endDateAsc') {
        this.sort = { endDate: 1 };
      } else if (this.sortBy === '_id') {
        this.sort = { _id: -1 };
        // } else if (this.sortBy === '_idAsc') {
        // this.sort = { _id: 1 };
      } else {
        // Default: businessDate
        this.sort = { businessDate: -1 };
      }
    },
    async loadOptions() {
      try {
        const res = await api.get(
          '/v1/system-config/get/crm/CRM_EXPIRY_ALERT_END_DATE_FLOOR',
        );
        this.crmExpiryAlertEndDateFloor = res.data?.value || null;

        const allOptions = await getOptions(api, {
          filter: { type: 'crm' },
          sort: { order: 1, createdAt: -1 },
        });

        const options = allOptions.docs || allOptions;

        this.agencyOptions = options
          .filter(opt => opt.subType === crmOptionsSubTypes.agency)
          .map(opt => opt.name);

        this.depPlaceOptions = options
          .filter(opt => opt.subType === crmOptionsSubTypes.fileStoragePlace)
          .map(opt => opt.name);
      } catch (e) {
        this.crmExpiryAlertEndDateFloor = '2026-06-30';
      }
    },
    applyFilters() {
      // Apply pending values to actual filter values
      this.searchField = this.pendingSearchField;
      this.search = this.pendingSearchVal || '';
      this.filters = { ...this.pendingFilters };
      this.sortBy = this.pendingSortBy;
      this.updateSort();

      this.debouncedSearch();
    },
    isCrmExpiryAlertEndDateEligible(endDate) {
      if (!endDate || !this.crmExpiryAlertEndDateFloor) return false;
      return !dayjs(endDate)
        .startOf('day')
        .isBefore(dayjs(this.crmExpiryAlertEndDateFloor).startOf('day'));
    },
    isCrmSpecialRecord(item) {
      if (!item) return false;
      if (item.isSpecialRecord === true) return true;
      if (item.isSpecialRecord === false) return false;
      if (!item.businessDate || !item.endDate) return false;
      const standardEnd = dayjs(item.businessDate)
        .add(1, 'year')
        .subtract(1, 'day')
        .startOf('day');
      return !dayjs(item.endDate).startOf('day').isSame(standardEnd, 'day');
    },
    /** endDate strictly before today (calendar day) */
    isCrmExpiryAlertEndDateOverdue(endDate) {
      if (!endDate) return false;
      return dayjs(endDate).startOf('day').isBefore(dayjs().startOf('day'));
    },
    /** endDate is today (calendar day) */
    isCrmExpiryAlertEndDateToday(endDate) {
      if (!endDate) return false;
      return dayjs(endDate).startOf('day').isSame(dayjs().startOf('day'));
    },
    /** endDate within next 2 calendar days (incl. today; excludes overdue) */
    isExpiryAlertWithinWindow(endDate) {
      if (!endDate) return false;
      const today = dayjs().startOf('day');
      const end = dayjs(endDate).startOf('day');
      const daysUntil = end.diff(today, 'day');
      return daysUntil >= 0 && daysUntil <= 2;
    },
    isExpiryAlertBlockedByRnt(rnt) {
      return (
        rnt === rnTypes.Renewed ||
        rnt === rnTypes.Cancelled ||
        rnt === rnTypes.Abandoned ||
        rnt === rnTypes.Sold ||
        rnt === rnTypes.NonRenewal
      );
    },
    isCrmExpiryAlertActive(item) {
      if (!item?.endDate) return false;
      if (this.isExpiryAlertBlockedByRnt(item?.RNT)) return false;
      if (this.isCrmExpiryAlertEndDateOverdue(item.endDate)) return false;
      if (!this.isCrmExpiryAlertEndDateEligible(item?.endDate)) return false;
      return this.isExpiryAlertWithinWindow(item.endDate);
    },
    getCrmRowClass(item) {
      if (!item?.endDate) return '';
      if (this.isExpiryAlertBlockedByRnt(item?.RNT)) return '';
      if (
        this.isCrmExpiryAlertEndDateEligible(item.endDate) &&
        (this.isCrmExpiryAlertEndDateOverdue(item.endDate) ||
          this.isCrmExpiryAlertEndDateToday(item.endDate))
      ) return 'crm-expiry-alert-row-overdue';
      if (
        this.isCrmExpiryAlertEndDateEligible(item?.endDate) &&
        this.isExpiryAlertWithinWindow(item.endDate)
      ) {
        return 'crm-expiry-alert-row-within-window';
      }
      return '';
    },
    resetFilters() {
      // Reset only pending filters (not applied filters)
      this.pendingSearchField = 'ContactPerson';
      this.pendingSearchVal = '';
      this.pendingFilters = {
        insType: null,
        businessDateStart: null,
        businessDateEnd: null,
        endDateStart: null,
        endDateEnd: null,
        agency: null,
        depPlace: null,
        needFile: null,
        rnType: null,
        expiryAlert: false,
      };
      this.pendingSortBy = 'businessDate';
    },
    actionCreate() {
      this.editId = 'new';
      this.initialData = null;
      this.editDialog = true;
    },
    actionDetails(item) {
      this.editId = item._id;
      this.initialData = null;
      this.editDialog = true;
    },
    handleSaved() {
      this.initialData = null;
      this.reload();
    },
    handleDeleted() {
      this.initialData = null;
      this.reload();
    },
    handleDuplicate(data) {
      // Close current dialog and open a new one with duplicated data
      this.editId = 'new';
      const sourceId = data._id != null ? String(data._id) : null;
      this.initialData = {
        ...pick(data, [
          'insPlace',
          'ContactPerson',
          'insType',
          'NAMEOFINS',
          'D1',
          'AGENCY',
          'TEL',
          'agent',
          'agentTel',
        ]),
        // Set inputDate to today for the duplicate record
        data: [
          {
            //inputDate: dayjs().toDate(),
            ...pick(data.data?.[0] || {}, ['VEHNO', 'MAKE', 'MODEL', 'YEAR']),
          },
        ],
        ...(sourceId ? { duplicatedFromCrmId: sourceId, RNT: rnTypes.RN } : {}),
      };
      // Use nextTick to ensure the dialog re-renders with new data
      this.$nextTick(() => {
        this.editDialog = true;
      });
    },
    async updateRNTimestamp(item) {
      if (!item._id) return;

      try {
        await api.patch(`${RESTFUL.crm.update}/${item._id}`, {
          RN: new Date(),
        });

        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'RN時間已更新',
          type: 'success',
          color: 'success',
        });

        this.reload();
      } catch (e) {
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: e.message || '更新失敗',
          type: 'error',
          color: 'error',
        });
      }
    },
    openRNDateDialog(item) {
      this.rnDateEditData = {
        _id: item._id,
        RNDate: item.RN ? dayjs(item.RN).format('YYYY-MM-DD') : null,
      };
      this.rnDateDialog = true;
    },
    closeRNDateDialog() {
      this.rnDateDialog = false;
      this.rnDateMenu = false;
      this.rnDateEditData = {
        _id: null,
        RNDate: null,
      };
    },
    async updateRNDate() {
      if (!this.rnDateEditData._id) return;

      this.rnDateSaving = true;
      try {
        const updateData = {
          RN: this.rnDateEditData.RNDate
            ? dayjs(this.rnDateEditData.RNDate).startOf('day').toDate()
            : null,
        };

        await api.patch(`${RESTFUL.crm.update}/${this.rnDateEditData._id}`, updateData);

        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'RN日期已更新',
          type: 'success',
          color: 'success',
        });

        this.closeRNDateDialog();
        this.reload();
      } catch (e) {
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: e.message || '更新失敗',
          type: 'error',
          color: 'error',
        });
      } finally {
        this.rnDateSaving = false;
      }
    },
    openRNDialog(item) {
      this.rnEditData = {
        _id: item._id,
        RNT: item.RNT || '',
      };
      this.rnDialog = true;
    },
    closeRNDialog() {
      this.rnDialog = false;
      this.rnEditData = {
        _id: null,
        RNT: null,
      };
    },
    async updateRNStatus() {
      if (!this.rnEditData._id) return;

      this.rnSaving = true;
      try {
        await api.patch(`${RESTFUL.crm.update}/${this.rnEditData._id}`, {
          RNT: this.rnEditData.RNT,
        });

        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'RN狀態更新成功',
          type: 'success',
          color: 'success',
        });

        this.closeRNDialog();
        this.reload();
      } catch (e) {
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: e.message || '更新失敗',
          type: 'error',
          color: 'error',
        });
      } finally {
        this.rnSaving = false;
      }
    },
    openFilteredDialog(field, value) {
      this.filterField = field;
      this.filterValue = value;
      this.filteredDialog = true;
    },
    handleOpenDetails(id) {
      this.editId = id;
      this.editDialog = true;
    },
    /** Still used by agentTel column (TEL uses Cloud renewal dialog). */
    generateWhatsAppUrl(phoneNumber, item) {
      if (!phoneNumber) return '#';

      // Format phone number - remove any spaces, dashes, or special characters
      let _phoneNumber = phoneNumber.replace(/[\s\-()]/g, '');

      // Prepend 852 if not already present
      if (!_phoneNumber.startsWith('852')) {
        _phoneNumber = '852' + _phoneNumber;
      }

      // Calculate expiry date (businessDate + 1 year)
      const expiryDate = item.endDate ? dayjs(item.endDate).format('YYYY-MM-DD') : '';

      // Get customer name and vehicle number
      const customerName = item.ContactPerson || '';
      const vehicleNumber = item.VEHNO || '';
      const insuranceType = translateOptions(item.insType, insuranceTypeOptions, 'value', 'text');

      // Construct the message with dynamic data
      const message = `佑安保險代理丨續保通知：保單將於${expiryDate}到期，被保人${customerName}，保險種類: ${insuranceType}，車牌號碼 (如適用): ${vehicleNumber}。 請聯絡本公司 Bonnie 6696-7236 或 Ava 9373-1297 安排續保。如已辦妥，可不用理會此通知，謝謝！`;

      // URL encode the message
      const encodedMessage = encodeURIComponent(message);

      // Return the full WhatsApp URL
      return `https://api.whatsapp.com/send?phone=${_phoneNumber}&text=${encodedMessage}`;
    },
    // Replaced by Cloud docs-request dialog (openDocsRequestDialog / sendDocsRequestWhatsapp).
    // Old wa.me prefill kept for reference:
    // generateReminderWhatsAppUrl(phoneNumber, item) {
    //   if (!phoneNumber) return '#';
    //   // Company WhatsApp number
    //   // Format phone number - remove any spaces, dashes, or special characters
    //   let _phoneNumber = phoneNumber.replace(/[\s\-()]/g, '');
    //
    //   // Prepend 852 if not already present
    //   if (!_phoneNumber.startsWith('852')) {
    //     _phoneNumber = '852' + _phoneNumber;
    //   }
    //
    //   // Get customer and vehicle details
    //   const customerName = item.ContactPerson || '___________';
    //   const vehicleMake = item.MAKE || '___________';
    //   const vehicleYear = item.YEAR || '___________';
    //
    //   // Construct the reminder message
    //   const message = `您好，我們是 佑安保險代理公司。
    // 為安排保險公司處理正式保險單核發，
    // 請提供以下車輛的牌簿清晰影本，
    // 並以 WhatsApps 傳送至 6696 7236。
    //
    // 保險單受保人：${customerName}
    // 車款：${vehicleMake}
    // 出廠年份：${vehicleYear}
    //
    // 正式保險單一經發出，
    // 我們將以 WhatsApps 傳送檔案副本給您作備存。
    // 如有任何查詢，請聯絡：
    // 陳小姐（9373 1297）
    // 黃小姐（6696 7236）
    // 感謝您的配合！`;
    //
    //   // URL encode the message
    //   const encodedMessage = encodeURIComponent(message);
    //
    //   // Return the full WhatsApp URL
    //   return `https://api.whatsapp.com/send?phone=${_phoneNumber}&text=${encodedMessage}`;
    // },
    docsRequestNonEmpty(value, fallback = '-') {
      const trimmed = value == null ? '' : String(value).trim();
      return trimmed || fallback;
    },
    formatDocsRequestPhone(phoneNumber) {
      if (!phoneNumber) {
        return '';
      }
      let digits = String(phoneNumber).replace(/[^\d]/g, '');
      if (!digits.startsWith('852') && digits.length <= 8) {
        digits = '852' + digits;
      }
      return digits;
    },
    openDocsRequestDialog(item) {
      const phone = this.formatDocsRequestPhone(item.TEL || item.agentTel);
      this.docsRequestForm = {
        to: phone,
        insuredName: this.docsRequestNonEmpty(item.ContactPerson),
        coverNoteNumber: this.docsRequestNonEmpty(item.CNNO || item.N1),
        vehicleMake: this.docsRequestNonEmpty(item.MAKE),
        vehicleModel: this.docsRequestNonEmpty(item.MODEL),
        yearOfManufacture: this.docsRequestNonEmpty(item.YEAR),
      };
      this.docsRequestDialog = true;
    },
    closeDocsRequestDialog() {
      if (this.docsRequestSending) {
        return;
      }
      this.docsRequestDialog = false;
    },
    async sendDocsRequestWhatsapp() {
      const payload = {
        to: this.docsRequestNonEmpty(this.docsRequestForm.to, ''),
        insuredName: this.docsRequestNonEmpty(this.docsRequestForm.insuredName),
        coverNoteNumber: this.docsRequestNonEmpty(
          this.docsRequestForm.coverNoteNumber,
        ),
        vehicleMake: this.docsRequestNonEmpty(this.docsRequestForm.vehicleMake),
        vehicleModel: this.docsRequestNonEmpty(
          this.docsRequestForm.vehicleModel,
        ),
        yearOfManufacture: this.docsRequestNonEmpty(
          this.docsRequestForm.yearOfManufacture,
        ),
      };
      if (!payload.to) {
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: '請填寫收件人電話',
          type: 'error',
          color: 'error',
        });
        return;
      }

      this.docsRequestSending = true;
      try {
        const { data } = await api.post(
          RESTFUL.whatsappCloud.policyDocsRequestWithoutAttachment,
          payload,
        );
        const success = data?.success !== false;
        const errorMsg =
          data?.error?.message ||
          data?.message ||
          (success ? 'WhatsApp 訊息已傳送' : '傳送失敗');
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: success ? data?.message || 'WhatsApp 訊息已傳送' : errorMsg,
          type: success ? 'success' : 'error',
          color: success ? 'success' : 'error',
        });
        if (success) {
          this.docsRequestDialog = false;
        }
      } catch (error) {
        const responseData = error?.response?.data;
        const msg =
          responseData?.error?.message ||
          responseData?.message ||
          error?.message ||
          '傳送失敗';
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: Array.isArray(msg) ? msg.join(', ') : String(msg),
          type: 'error',
          color: 'error',
        });
      } finally {
        this.docsRequestSending = false;
      }
    },
    openRenewalNoticeDialog(item) {
      const phone = this.formatDocsRequestPhone(item.TEL);
      const policyNumber =
        (item.POLICYNO && String(item.POLICYNO).trim()) ||
        (item.N1 && String(item.N1).trim()) ||
        '-';
      this.renewalNoticeForm = {
        to: phone,
        expiryDate: item.endDate ? dayjs(item.endDate).format('YYYY-MM-DD') : '-',
        insuredName: this.docsRequestNonEmpty(item.ContactPerson),
        insuranceType: this.docsRequestNonEmpty(
          translateOptions(item.insType, insuranceTypeOptions, 'value', 'text'),
        ),
        policyNumber,
        licencePlate: this.docsRequestNonEmpty(item.VEHNO),
      };
      this.renewalNoticeDialog = true;
    },
    closeRenewalNoticeDialog() {
      if (this.renewalNoticeSending) {
        return;
      }
      this.renewalNoticeDialog = false;
    },
    async sendRenewalNoticeWhatsapp() {
      const payload = {
        to: this.docsRequestNonEmpty(this.renewalNoticeForm.to, ''),
        expiryDate: this.docsRequestNonEmpty(this.renewalNoticeForm.expiryDate),
        insuredName: this.docsRequestNonEmpty(this.renewalNoticeForm.insuredName),
        insuranceType: this.docsRequestNonEmpty(
          this.renewalNoticeForm.insuranceType,
        ),
        policyNumber: this.docsRequestNonEmpty(
          this.renewalNoticeForm.policyNumber,
        ),
        licencePlate: this.docsRequestNonEmpty(
          this.renewalNoticeForm.licencePlate,
        ),
      };
      if (!payload.to) {
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: '請填寫收件人電話',
          type: 'error',
          color: 'error',
        });
        return;
      }

      this.renewalNoticeSending = true;
      try {
        const { data } = await api.post(
          RESTFUL.whatsappCloud.policyRenewalNoticeWithoutAttachment,
          payload,
        );
        const success = data?.success !== false;
        const errorMsg =
          data?.error?.message ||
          data?.message ||
          (success ? 'WhatsApp 訊息已傳送' : '傳送失敗');
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: success ? data?.message || 'WhatsApp 訊息已傳送' : errorMsg,
          type: success ? 'success' : 'error',
          color: success ? 'success' : 'error',
        });
        if (success) {
          this.renewalNoticeDialog = false;
        }
      } catch (error) {
        const responseData = error?.response?.data;
        const msg =
          responseData?.error?.message ||
          responseData?.message ||
          error?.message ||
          '傳送失敗';
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: Array.isArray(msg) ? msg.join(', ') : String(msg),
          type: 'error',
          color: 'error',
        });
      } finally {
        this.renewalNoticeSending = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.contact-name-ellipsis {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep th.crm-contact-person-col,
::v-deep td.crm-contact-person-col {
  max-width: 220px !important;
  width: 220px !important;
  min-width: 220px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep th.crm-nameofins-col,
::v-deep td.crm-nameofins-col {
  max-width: 80px !important;
  width: 80px !important;
  min-width: 80px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep th.crm-make-model-col,
::v-deep td.crm-make-model-col {
  max-width: 72px !important;
  width: 72px !important;
  min-width: 72px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Print should wrap long customer names (match CNNO behavior which doesn't force nowrap) */
.contact-name-print-wrap {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

@mixin crm-colored-row($color) {
  color: $color !important;
  font-weight: 600;

  a,
  .clickable-link,
  .v-btn {
    color: $color !important;
  }
}

::v-deep .crm-expiry-alert-row-overdue {
  @include crm-colored-row(var(--yomt-row-red));
}

::v-deep .crm-expiry-alert-row-within-window {
  @include crm-colored-row(var(--yomt-row-green));
}
</style>

<style lang="scss">
@media print {
  .crm-expiry-alert-row-overdue {
    color: var(--yomt-row-red) !important;
    font-weight: 600;
  }

  .crm-expiry-alert-row-overdue a,
  .crm-expiry-alert-row-overdue .clickable-link {
    color: var(--yomt-row-red) !important;
  }

  .crm-expiry-alert-row-within-window {
    color: var(--yomt-row-green) !important;
    font-weight: 600;
  }

  .crm-expiry-alert-row-within-window a,
  .crm-expiry-alert-row-within-window .clickable-link {
    color: var(--yomt-row-green) !important;
  }
}
</style>
